export const ACCOUNT_PLATFORM = {
    TELEGRAM: 'telegram',
    TIKTOK: 'tiktok',
};
export const ACCOUNT_PLATFORM_VALUES = Object.values(ACCOUNT_PLATFORM);
export const ACCOUNT_STATUS = {
    ACTIVE: 'active',
    PAUSED: 'paused',
    BANNED: 'banned',
};
export const ACCOUNT_STATUS_VALUES = Object.values(ACCOUNT_STATUS);
//# sourceMappingURL=account-platform.js.map